import React from 'react';
import { Banner } from '@morressier/alembic';
import { useQuery } from '@tanstack/react-query';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from 'react-router-dom';
import { fetchMyRoleInSubmissionContext, fetchSubmissionContext } from 'src/api/queries';

export const EditorialRoleInfo: React.FC = () => {
  const { ctxId = "" } = useParams();
  const { data: journalRole } = useQuery(
    {
      queryKey: ['journal-role', ctxId],
      queryFn: () => fetchMyRoleInSubmissionContext(ctxId)
    }
  );

  const { data: journal } = useQuery(
    {
      queryKey: ['journal', ctxId],
      queryFn: () => fetchSubmissionContext(ctxId)
    }
  );

  const showMissingEditorialRoleWarning = journal && journalRole && journalRole.data === null;

  return (
    <>
      {showMissingEditorialRoleWarning && (
        <Banner
          variant='attention'
          customIcon={<FontAwesomeIcon icon={faExclamationCircle} />}
          heading={`You are not part of ${journal?.data.name}'s editorial staff.`}
          content={`As a member of this organization, you have visitor-access to all Journals. However, participating in the editorial process is restricted to a Journal's editorial staff.`}
        />
      )}
    </>
  );
};
